import React from 'react';
import Container from './Container';
import Row from './Row';
import Day from './Day';

export default ({ location }) => (
  <Container>
    {location.hours_of_operation.map((day, index) => (
      <Row key={index}>
        <Day>{day.dayOfWeek}</Day>
        <div>{day.hours}</div>
      </Row>
    ))}
  </Container>
);
